module.exports = __webpack_public_path__ + "src/assets/games/1/301.jpg";